import React from "react";
import TopBar from "@/components/layout/TopBar";
import Footer from "@/components/layout/Footer";
import { CARRIAGE_TERMS_TEXT } from "@/data/legalContent";

// Splits the flowing clause text into individual numbered paragraphs for
// proper typographic rendering (rather than one dense preformatted block).
const CLAUSES = CARRIAGE_TERMS_TEXT.split(/\n\n+/).map((block) => {
  const match = block.match(/^(\d+)\.\s*([\s\S]*)$/);
  return match ? { number: match[1], text: match[2] } : { number: null, text: block };
});

export default function Terms() {
  return (
    <div className="min-h-screen relative overflow-x-hidden">
      <div className="relative z-10">
        <TopBar />

        <section className="max-w-[1400px] mx-auto px-6 lg:px-8 py-20 md:py-28">
          <div className="max-w-3xl fade-up">
            <p className="font-display tracking-[0.4em] text-[#19e6c8] text-sm">LEGAL</p>
            <h1 className="brand-title text-4xl sm:text-5xl mt-4 leading-tight">
              Terms &amp; Conditions of Carriage
            </h1>
            <p className="text-white/50 mt-4 text-sm">
              These terms govern the carriage and/or storage of goods by DRIVN FREIGHT PTY LTD
              (ABN 41 658 624 385) trading as DRIVN FREIGHT.
            </p>
          </div>

          <div className="max-w-3xl mt-14 space-y-7" data-testid="terms-page-content">
            {CLAUSES.map((c, i) => (
              <p key={i} className="text-white/70 text-[15px] leading-relaxed whitespace-pre-line">
                {c.number && <span className="text-[#19e6c8] font-semibold mr-2">{c.number}.</span>}
                {c.text}
              </p>
            ))}
          </div>
        </section>

        <Footer />
      </div>
    </div>
  );
}
